<div
    class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0"
>
    <div
        class="md:flex md:items-center md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card"
    >
        <div class="w-full max-w-180 md:w-180 sm:w-80 mx-auto sm:mx-0">
            <!-- Logo -->
            <div class="w-12 mx-auto" style="text-align: center;">
                <img src="assets/images/logo/logo.png" />
            </div>

            <!-- Title -->
            <div
                class="mt-12 text-4xl font-extrabold tracking-tight leading-tight text-center"
            >
                Connexion
            </div>
            <div class="flex items-baseline mt-0.5 font-medium">
                <div>Je n'ai pas de compte?</div>
                <a
                    class="ml-1 text-primary-500 hover:underline"
                    [routerLink]="['/sign-up']"
                    >Activation compte
                </a>
            </div>

            <!-- Alert -->
            <fuse-alert
                class="mt-8"
                *ngIf="showAlert"
                [appearance]="'outline'"
                [showIcon]="false"
                [type]="alert.type"
                [@shake]="alert.type === 'error'"
            >
                {{ alert.message }}
            </fuse-alert>

            <!-- Sign in form -->
            <form class="mt-8" [formGroup]="signInForm" #signInNgForm="ngForm">
                <!-- Email field -->
                <mat-form-field class="w-full">
                    <mat-label>Email address</mat-label>
                    <input id="email" matInput [formControlName]="'email'" />
                    <mat-error
                        *ngIf="signInForm.get('email').hasError('required')"
                    >
                    Adresse e-mail est nécessaire
                    </mat-error>
                    <mat-error
                        *ngIf="signInForm.get('email').hasError('email')"
                    >
                    S'il vous plaît, mettez une adresse email valide
                    </mat-error>
                </mat-form-field>

                <!-- Password field -->
                <mat-form-field class="w-full">
                    <mat-label>Mot de passe</mat-label>
                    <input
                        id="password"
                        matInput
                        type="password"
                        [formControlName]="'password'"
                        #passwordField
                    />
                    <button
                        mat-icon-button
                        type="button"
                        (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        "
                        matSuffix
                    >
                        <mat-icon
                            class="icon-size-5"
                            *ngIf="passwordField.type === 'password'"
                            [svgIcon]="'heroicons_solid:eye'"
                        ></mat-icon>
                        <mat-icon
                            class="icon-size-5"
                            *ngIf="passwordField.type === 'text'"
                            [svgIcon]="'heroicons_solid:eye-off'"
                        ></mat-icon>
                    </button>
                    <mat-error> Le Mot de passe est requis </mat-error>
                </mat-form-field>

                <!-- Actions -->
                <div
                    class="inline-flex items-center justify-between w-full mt-1.5">
                    <a
                        class="text-md font-medium text-primary-500 hover:underline"
                        [routerLink]="['/forgot-password']"
                        >Mot de passe oublié?
                    </a>
                </div>

                <!-- Submit button -->
                <button
                    class="fuse-mat-button-large w-full mt-6"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="signInForm.disabled"
                    (click)="signIn()">
                    <span *ngIf="!signInForm.disabled"> Se connecter </span>
                    <mat-progress-spinner
                        *ngIf="signInForm.disabled"
                        [diameter]="24"
                        [mode]="'indeterminate'"
                    ></mat-progress-spinner>
                </button>
            </form>
        </div>
    </div>

    <div class="w-full h-full hidden md:block">
        <div class="flex flex-col flex-auto min-w-0">

            <!-- Header -->
            <div class="relative pt-8 pb-28 px-4 sm:pt-20 sm:pb-48 sm:px-16 overflow-hidden bg-gray-800 dark:bg-gray-900 dark">
                <!-- Background - @formatter:off -->
                <!-- Rings -->
                <svg class="absolute inset-0 pointer-events-none"
                     viewBox="0 0 960 540" width="100%" height="100%" preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
                    <g class="text-gray-700 opacity-25" fill="none" stroke="currentColor" stroke-width="100">
                        <circle r="234" cx="196" cy="23"></circle>
                        <circle r="234" cx="790" cy="491"></circle>
                    </g>
                </svg>
                <!-- @formatter:on -->
                <div class="z-10 relative flex flex-col items-center">
                    <h2 class="text-xl font-semibold">  l'ENT</h2>
                    <div class="mt-1 text-4xl sm:text-7xl font-extrabold tracking-tight leading-tight text-center">
                        Bienvenue dans l'ENT
                    </div>
                </div>
            </div>

            <div class="flex flex-col items-center pb-6 px-6 sm:pb-10 sm:px-10">
                <!-- Cards -->
                <div class="grid grid-cols-1 md:grid-cols-3 gap-y-8 md:gap-y-0 md:gap-x-6 w-full max-w-sm md:max-w-4xl -mt-16 sm:-mt-24">
                    <!-- FAQs card -->
                    <div class="relative mat-elevation-z21 flex flex-col rounded-2xl shadow hover:shadow-lg overflow-hidden bg-card transition-shadow ease-in-out duration-150">
                        <div class="flex flex-col flex-auto items-center p-8 text-center">
                            <div class="text-2xl font-semibold">Emplois du temps</div>
                            <div class="md:max-w-40 mt-1 text-secondary">Ce module contient tout ce qui est relatif aux emplois du temps</div>
                        </div>

                    </div>
                    <br>
                    <br>
                    <!-- Guides card -->
                    <div class="relative flex flex-col rounded-2xl shadow hover:shadow-lg overflow-hidden bg-card transition-shadow ease-in-out duration-150">
                        <div class="flex flex-col flex-auto items-center p-8 text-center">
                            <div class="text-2xl font-semibold">bulletins</div>
                            <div class="md:max-w-40 mt-1 text-secondary">Ce module contient tout ce qui est relatif aux bulletins</div>
                        </div>

                    </div>
                    <br>
                    <br>
                    <!-- Support card -->
                    <div class="relative  mat-elevation-z21 flex flex-col rounded-2xl shadow hover:shadow-lg overflow-hidden bg-card transition-shadow ease-in-out duration-150">
                        <div class="flex flex-col flex-auto items-center p-8 text-center">
                            <div class="text-2xl font-semibold">Réclamations</div>
                            <div class="md:max-w-40 mt-1 text-secondary">Ce module contient tout ce qui est relatif aux reclamations </div>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="relative  mat-elevation-z21 flex flex-col rounded-2xl shadow hover:shadow-lg overflow-hidden bg-card transition-shadow ease-in-out duration-150">
                        <div class="flex flex-col flex-auto items-center p-8 text-center">
                            <div class="text-2xl font-semibold">Alumni</div>
                            <div class="md:max-w-40 mt-1 text-secondary">Ce module contient tout ce qui est relatif aux alumnis </div>
                        </div>

                    </div>
                    <br>
                    <br>
                    <div class="relative  mat-elevation-z21 flex flex-col rounded-2xl shadow hover:shadow-lg overflow-hidden bg-card transition-shadow ease-in-out duration-150">
                        <div class="flex flex-col flex-auto items-center p-8 text-center">
                            <div class="text-2xl font-semibold">Stage</div>
                            <div class="md:max-w-40 mt-1 text-secondary">Ce module contient tout ce qui est relatif aux stage </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>

    </div>
</div>
